import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';

const { FiCheckCircle } = FiIcons;

const stats = [
  { value: '100+', label: 'Cleaning Campaigns Managed', sub: 'Google Ads & Bing Ads' },
  { value: '4%', label: 'Monthly Growth Rate', sub: 'From Google Search (avg client)' },
  { value: '3+ Yrs', label: 'Average Client Retention', sub: 'Because results keep them' },
  { value: '#1', label: 'Cleaning Marketing Agency', sub: 'Specialized, focused, proven' },
];

const checklist = [
  'SEO-optimized websites that rank on page 1',
  'Google Ads campaigns with proven ROI',
  'Facebook ads targeting your ideal buyer',
  'Reputation management that fills your pipeline',
  'Marketing automation that nurtures on autopilot',
  'Local Maps optimization to the top 3 positions',
];

const SocialProof = () => {
  return (
    <section className="py-24 md:py-32 bg-[#4b4b4b] relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-[#8cc63f] rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#8cc63f] rounded-full blur-3xl translate-x-1/2 translate-y-1/2" />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <span className="text-[#8cc63f] font-semibold text-sm uppercase tracking-widest block mb-4">
              Proven Track Record
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 tracking-tight leading-tight">
              Make Sure You're Staying On Top of Your Competition
            </h2>
            <p className="text-gray-300 text-lg mb-8 leading-relaxed">
              Get your <strong className="text-white">free cleaning business marketing checklist</strong> now and see exactly where your business stands — and what to do next.
            </p>
            <ul className="space-y-3 mb-10">
              {checklist.map((item) => (
                <li key={item} className="flex items-start gap-3 text-gray-300">
                  <FiCheckCircle className="text-[#8cc63f] mt-0.5 flex-shrink-0 text-lg" />
                  <span className="text-sm">{item}</span>
                </li>
              ))}
            </ul>
            <a
              href="#strategy"
              className="inline-flex items-center gap-2 px-8 py-4 bg-[#8cc63f] hover:bg-[#7ab535] text-white font-bold rounded-full transition-all shadow-2xl"
            >
              Get My Free Marketing Checklist
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="grid grid-cols-2 gap-5"
          >
            {stats.map((stat, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, scale: 0.85 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.1 }}
                className="text-center p-8 rounded-2xl bg-white/10 backdrop-blur-sm border border-white/20"
              >
                <div className="text-4xl font-black text-[#8cc63f] mb-2">{stat.value}</div>
                <div className="text-white font-semibold text-sm mb-1">{stat.label}</div>
                <div className="text-gray-400 text-xs">{stat.sub}</div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;